define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrTypeDomain = void 0;
    class SrTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: SrTypeDomain.Road, value: "Road" },
                    { key: SrTypeDomain.Reserve, value: "Reserve" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[SrTypeDomain.Road] = 0;
                this.KeyIndex[SrTypeDomain.Reserve] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Road"] = 0;
                this.ValueIndex["Reserve"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.SrTypeDomain = SrTypeDomain;
    Object.defineProperty(SrTypeDomain, "Road", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "RO"
    });
    Object.defineProperty(SrTypeDomain, "Reserve", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "RE"
    });
    Object.defineProperty(SrTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
